import {Component, HostBinding, Input, OnChanges, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NavService} from '../../../../../services/nav.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {RouteMasterService} from 'src/app/route-master.service';
import {environment} from "../../../../../../environments/environment";
import {routesList} from "../../../../../enums/route-list-master";
import {AuthService} from "../../../../../services/auth.service";

@Component({
    selector: 'app-menu-list-item',
    templateUrl: './menu-list-item.component.html',
    styleUrls: ['./menu-list-item.component.scss'],

    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({transform: 'rotate(0deg)'})),
            state('expanded', style({transform: 'rotate(180deg)'})),
            transition('expanded <=> collapsed',
                animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
            ),
        ])
    ]
})

export class MenuListItemComponent implements OnInit, OnChanges {
    @Input() expanded: any = false;
    @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
    @Input() item;
    @Input() depth: any;
    @Input()
    goto_url: string = ''

    constructor(public navService: NavService,
                public router: Router,
                private routeMasterService: RouteMasterService,
                private authService: AuthService) {
        if (this.depth === undefined) {
            this.depth = 0;
        }
    }

    ngOnInit() {
        if (this.item.menus) {
            this.navService.landingPage.subscribe((skipTutorial: any) => {
                if (skipTutorial) {
                    this.item.menus.map((item: any) => {
                        const route = routesList.find(route => route.tutorialPage === item.route);
                        if (route != undefined)
                            item.route = route.listPage
                    })
                } else {
                    this.item.menus.map((item: any) => {
                        const route = routesList.find(route => route.listPage === item.route);
                        if (route != undefined)
                            item.route = route.tutorialPage;
                    })
                }
            });
        }
    }

    ngOnChanges() {
        this.navService.currentUrl.subscribe((url: string) => {
            if (this.item.route && url) {
                this.expanded = url.indexOf(`/${this.item.route}`) === 0;
                this.ariaExpanded = this.expanded;

            }
        });

    }

    gotoApp() {
        if (this.goto_url != '') {
            let encodedUrl = encodeURIComponent(this.goto_url)
            window.open(environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl, '_blank');
        }
    }

    onItemSelected(item) {
        // if (!item.menus || !item.menus.length) {
        // if (!item.route) {
        //     this.router.navigate([this.routeMasterService.getUrlByDBValue(item.page_url)]);
        // } else {
        //     this.router.navigate([item.route]);
        // }
        // this.router.navigate([item.route]);
        // }
        if (item.menus && item.menus.length) {
            this.expanded = !this.expanded;
        }
        if (item.displayName == 'Invoices') {
            this.gotoApp();
        }
    }

}
